import { CartProductCode, Member, MembershipLevel, PriceCart } from '@ace-clublabs/common-membership-api-types';
import { NewJoinSessionData } from '../application/models/NewJoinSessionData';

export class benefitsHelper {
  static sortObjectByKey(obj: object) {
    const sortedArray = Object.entries(obj)
      .map(([key, value]) => ({ key, ...value }))
      .sort((a, b) => {
        const orderA = a.shortSortOrder.split(':');
        const orderB = b.shortSortOrder.split(':');
        for (let i = 0; i < Math.max(orderA.length, orderB.length); i++) {
          const aPart = parseInt(orderA[i] || 0);
          const bPart = parseInt(orderB[i] || 0);
          if (aPart !== bPart) {
            return aPart - bPart;
          }
        }
        return 0;
      });

    const sortedObject = sortedArray.reduce((result, item) => {
      const { key, ...rest } = item;
      result[key] = { ...rest };
      return result;
    }, {});

    return sortedObject;
  }

  static combineLikeBenefits(sortedObject: any) {
    const obj: any = {};
    const result: any = [];
    for (const key in sortedObject) {
      const item = sortedObject[key];
      const soArr = item.shortSortOrder.split(':');
      const soKey = soArr[0];
      if (!obj[soKey]) {
        obj[soKey] = item.shortDescription;
      } else {
        obj[soKey] = `${obj[soKey]}/${item.shortDescription}`;
      }
    }

    for (const key in obj) {
      result.push(obj[key]);
    }
    return result;
  }

  static buildShortBenefits(shortBenefits: any, membershipLevel: any) {
    let level = membershipLevel?.toLowerCase();
    if (shortBenefits == null || !shortBenefits[level]) return [];

    const sortedObject = this.sortObjectByKey(shortBenefits[level]['benefitItems']);
    const combinedBenefits = this.combineLikeBenefits(sortedObject);
    return combinedBenefits;
  }

  static getBenefitsByMembershipLevel = (sessionData: NewJoinSessionData, membershipLevel: MembershipLevel) => {
    return sessionData.membershipContent?.additionalBenefits?.find(
      (benefits) => benefits.membershipLevel === membershipLevel
    );
  };

  static getMembershipCardVariant = (membershipInfo: any, membershipLevel: MembershipLevel) => {
    if (!membershipInfo) {
      return 'universal-classic';
    }
    const { clubCode } = membershipInfo;
    const level = membershipLevel.toLocaleLowerCase();
    switch (clubCode) {
      case '001':
        return `alabama-${level}`;
      case '004':
        return `ca-${level}`;
      case '065':
        return `acmo-${level}`;
      case '215':
        return `ec-${level}`;
      case '018':
        return `hi-${level}`;
      case '601':
        return `nm-${level}`;
      case '036':
        return `nne-${level}`;
      case '258':
        return `tw-${level}`;
      case '252':
        return `tx-${level}`;
      default:
        return `universal-${level}`;
    }
  };

  static getMembershipCardClubVariant = (membershipInfo: any) => {
    if (!membershipInfo) {
      return 'universal-classic';
    }
    const { clubCode } = membershipInfo;
    switch (clubCode) {
      case '001':
        return `alabama-`;
      case '004':
        return `ca-`;
      case '065':
        return `acmo-`;
      case '215':
        return `ec-`;
      case '018':
        return `hi-`;
      case '601':
        return `nm-`;
      case '036':
        return `nne-`;
      case '258':
        return `tw-`;
      case '252':
        return `tx-`;
      default:
        return `universal-`;
    }
  };

  static getDisclaimers = (membershipInfo: any, sessionData: NewJoinSessionData) => {
    if (!membershipInfo) {
      return `
      <div>
      
      </div>`;
    }

    //update to read disclaimer for memLevel once Plus and Premier disclaimers are available
    const { clubCode, requestedMembershipLevel } = membershipInfo;
    const level = requestedMembershipLevel?.toLowerCase();
    switch (clubCode) {
      case '001':
        return `alabama-${level}`;
      case '004':
        return `ca-${level}`;
      case '065':
        return `acmo-${level}`;
      case '215':
        return `ec-${level}`;
      case '018':
        return `hi-${level}`;
      case '601':
        return `nm-${level}`;
      case '036':
        return `nne-${level}`;
      case '258':
        return `tw-${level}`;
      case '252':
        return `tx-${level}`;
      default:
        return `universal-${level}`;
    }
  };

  static discountApplied = (priceCart: PriceCart | null | undefined) => {
    const autopayDiscount = priceCart?.items?.find((item) => item.code === CartProductCode.AUTOPAY_DISCOUNT);
    return (
      autopayDiscount != undefined ||
      priceCart?.items?.find((item) => item.discountedPrice !== undefined && item.price > item.discountedPrice) !=
        undefined
    );
  };

  static ERSApplied = (priceCart: PriceCart | null | undefined) => {
    const ERSCartItem = priceCart?.items?.find((item) => item.code === CartProductCode.ERSFEE);
    return ERSCartItem != undefined;
  };
}

export const ABBREVIATED_MEMBERSHIP_LEVELS = {
  [MembershipLevel.CLASSIC]: 'cl',
  [MembershipLevel.PLUS]: 'pl',
  [MembershipLevel.PREMIER]: 'pr',
  [MembershipLevel.CLASSIC_RV]: 'clrv',
  [MembershipLevel.PLUS_RV]: 'plrv',
  [MembershipLevel.PREMIER_RV]: 'prrv',
};
